import Head from 'next/head';
import { BaseDivider, EBaseDividerSize } from '@spinwise/react-component-library/BaseDivider';
import parse from 'html-react-parser';
import { internalFetch } from '../../utils';
import { t } from 'i18next';
import DefaultLayout from '../../components/layouts/default';
import styles from '../../components/shared/Footer/InfoModal/InfoModal.module.scss';

export async function getServerSideProps(context) {
  const res = await internalFetch(
    `/api/content/info-pages?brand=${process.env.STRAPI_BRAND}&slug=${context.query.page}&locale=${context.locale}&geo=${context?.req?.cookies?.country}`,
  );
  const { data = { result: null } } = res;

  if (!data?.result) {
    return {
      props: {},
      notFound: true,
    };
  }

  return {
    props: {
      ...data.result,
      pageSlug: context?.query?.page?.replace(/-/g, '.'),
    },
  };
}

export default function InfoModalPage(props) {
  return (
    <>
      <Head>
        <title>{t(`page.info.${props?.pageSlug}.meta.title`)}</title>
        <meta name="description" content={t(`page.info.${props?.pageSlug}.meta.description`)} />
      </Head>
      <DefaultLayout>
        {props?.text ? (
          <>
            <style>{props?.css?.css}</style>
            <div className="container-app">
              <div className={`${styles.modal} ${styles.modal_page}`}>
                <div className={styles.modal_content}>
                  <h1>{props?.title}</h1>
                  {props?.subtitle ? parse(props?.subtitle) : ''}
                  <div className={`${styles.modal_content_category} d-fl ai-c`}>
                    <span>{props?.date}</span>
                    <span className={styles.dot}></span>
                    <span>{props?.version}</span>
                  </div>
                  <BaseDivider size={EBaseDividerSize.FullWidth} />
                  <div className={styles.modal_content_text}>{parse(props?.text)}</div>
                </div>
              </div>
            </div>
          </>
        ) : null}
      </DefaultLayout>
    </>
  );
}
